import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  loading: false,
  uploadBillData: {},
  error: "",
  success: false,
  status: "",
};

const uploadBillCall = createAsyncThunk("post/uploadBill", async (data) => {
  try {
    const result = await axios.post(
      "https://apac.api.capillarytech.com/mobile/v2/api/ocr/receipt",
      data
    );
  
    return result?.data;
  } catch (err) {
    console.log(err);
  }
});

const uploadBillSlice = createSlice({
  name: "upload-bill",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(uploadBillCall.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(uploadBillCall.fulfilled, (state, action) => {
  
      state.loading = false;
      state.uploadBillData = action.payload;
      // state.success = action.payload?.status.success === "true" ? true : false;
      state.error = "";
    });
    builder.addCase(uploadBillCall.rejected, (state, action) => {
      state.loading = false;
      state.uploadBillData = {};
      state.error = action.error.message;
      state.success = false;
    });
  },
});

export default uploadBillSlice.reducer;
export const { reset } = uploadBillSlice.actions;
export { uploadBillCall };
